import React from 'react';

const RulesPage: React.FC = () => {
  return (
    <div style={{ padding: '50px', textAlign: 'center' }}>
      <h1>서버 규칙</h1>
      <p>깃북 서버 규칙을 웹사이트로 이동하여 수정 및 작성할 수 있는 페이지입니다.</p>
      <p>추후 구현 예정입니다.</p>
    </div>
  );
};

export default RulesPage;